import store from '@/store'


export default function (auth) {
    if (!auth) {
        return false
    }
    let functionPermissions = store.state.FunctionPermissions || []
    return functionPermissions.indexOf(auth) > -1;
}